import InViewManager from '../../../../managers/in-view';

export default class MapSingleRenderLoader {
  constructor(element) {
    if (document.querySelector('[data-component="MapSingle"]')) MapSingleRenderLoader.load(element);
  }

  static async load(element) {
    const { default: MapSingleRender } = await import(/* webpackChunkName: "MapSingleRender" */'../../../render/Maps/Single');

    new MapSingleRender(element);
  }
}
